import type {EditLeadContactFormPayload} from "./edit-lead-contact.schema";

import {editLeadContact} from "@project/sdk/sales";
import {EditLeadContactBody} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";

import {leadKeys, leadMutationKeys} from "../../../../../lead-keys";

import {editLeadContactMapper} from "./edit-lead-contact.mapper";

export function editLeadContactMutationOptions(leadId: string, contactId: number) {
  return mutationOptions({
    mutationKey: leadMutationKeys.editLeadContact,
    mutationFn: (formPayload: EditLeadContactFormPayload) => {
      const request = EditLeadContactBody.parse(editLeadContactMapper.toSdk(formPayload));

      return editLeadContact(leadId, contactId, request);
    },
    onSuccess: async (_result, _formPayload, _onMutateResult, {client}) => {
      await client.invalidateQueries({queryKey: leadKeys.detail(leadId)});
    },
  });
}
